export const featuredAnime = {
  id: 'featured-001',
  title: '鬼灭之刃 无限城篇',
  subtitle: '剧场版三部曲 最终决战揭幕',
  description: '炭治郎与鬼杀队踏入无限城，面对上弦之鬼的终极挑战，一场关乎人类命运的决战即将展开。',
  category: '热血战斗',
  rating: 9.8,
  episodeCount: 3,
  status: '上映中',
  coverSeq: 'featured-anime-cover',
};

export const animeList = [
  {
    id: 'anime-001',
    title: '鬼灭之刃 无限城篇',
    category: '热血战斗',
    coverSeq: 'anime-card-001',
    rating: 9.8,
    episodeCount: 3,
    status: '上映中',
    year: 2025,
    description: '炭治郎与鬼杀队踏入无限城，面对上弦之鬼的终极挑战。',
    tags: ['热血', '战斗', '少年'],
  },
  {
    id: 'anime-002',
    title: '我推的孩子 第三季',
    category: '偶像演艺',
    coverSeq: 'anime-card-002',
    rating: 9.5,
    episodeCount: 13,
    status: '连载中',
    year: 2025,
    description: '星野爱的秘密逐渐浮出水面，演艺圈的真相即将揭晓。',
    tags: ['偶像', '悬疑', '转生'],
  },
  {
    id: 'anime-003',
    title: '葬送的芙莉莲 第二季',
    category: '奇幻治愈',
    coverSeq: 'anime-card-003',
    rating: 9.7,
    episodeCount: 28,
    status: '连载中',
    year: 2025,
    description: '芙莉莲继续她的旅程，在人与魔族的纷争中寻找生命的意义。',
    tags: ['奇幻', '治愈', '冒险'],
  },
  {
    id: 'anime-004',
    title: '药屋少女的呢喃 第二季',
    category: '宫廷推理',
    coverSeq: 'anime-card-004',
    rating: 9.4,
    episodeCount: 24,
    status: '连载中',
    year: 2025,
    description: '猫猫在后宫中的药理知识继续发挥奇效，新的谜题接踵而至。',
    tags: ['推理', '宫廷', '医疗'],
  },
  {
    id: 'anime-005',
    title: '咒术回战 死灭回游篇',
    category: '热血战斗',
    coverSeq: 'anime-card-005',
    rating: 9.6,
    episodeCount: 24,
    status: '即将开播',
    year: 2025,
    description: '虎杖悠仁与伙伴们面对前所未有的诅咒危机，死灭回游正式开幕。',
    tags: ['热血', '战斗', '咒术'],
  },
  {
    id: 'anime-006',
    title: '间谍过家家 第三季',
    category: '喜剧日常',
    coverSeq: 'anime-card-006',
    rating: 9.3,
    episodeCount: 12,
    status: '连载中',
    year: 2025,
    description: '福杰一家的温馨日常继续，安妮亚的校园生活又有新进展。',
    tags: ['喜剧', '日常', '家庭'],
  },
  {
    id: 'anime-007',
    title: '迷宫饭 第二季',
    category: '美食冒险',
    coverSeq: 'anime-card-007',
    rating: 9.2,
    episodeCount: 24,
    status: '连载中',
    year: 2025,
    description: '莱欧斯一行人在迷宫中继续用魔物制作美味料理的奇妙旅程。',
    tags: ['美食', '冒险', '奇幻'],
  },
  {
    id: 'anime-008',
    title: '黑执事 寄宿学校篇',
    category: '悬疑推理',
    coverSeq: 'anime-card-008',
    rating: 9.1,
    episodeCount: 11,
    status: '已完结',
    year: 2024,
    description: '塞巴斯蒂安与夏尔潜入名门寄宿学校，调查神秘失踪事件。',
    tags: ['悬疑', '推理', '英伦'],
  },
];

export const seasonalAnime = [
  {
    id: 'season-001',
    title: 'Re：从零开始的异世界生活 第三季',
    category: '异世界奇幻',
    coverSeq: 'season-anime-001',
    rating: 9.4,
  },
  {
    id: 'season-002',
    title: '在地下城寻求邂逅是否搞错了什么 第五季',
    category: '冒险战斗',
    coverSeq: 'season-anime-002',
    rating: 8.9,
  },
  {
    id: 'season-003',
    title: '无职转生 第三季',
    category: '异世界转生',
    coverSeq: 'season-anime-003',
    rating: 9.3,
  },
  {
    id: 'season-004',
    title: '关于我转生变成史莱姆这档事 第四季',
    category: '异世界建国',
    coverSeq: 'season-anime-004',
    rating: 9.2,
  },
];

export const hotCategories = [
  { name: '热血战斗', slug: 'hot-blooded', count: 286, icon: 'ri-sword-line' },
  { name: '奇幻冒险', slug: 'fantasy-adventure', count: 342, icon: 'ri-compass-3-line' },
  { name: '恋爱日常', slug: 'romance-daily', count: 198, icon: 'ri-heart-line' },
  { name: '搞笑喜剧', slug: 'comedy', count: 175, icon: 'ri-emotion-laugh-line' },
  { name: '悬疑推理', slug: 'mystery', count: 134, icon: 'ri-search-eye-line' },
  { name: '科幻机甲', slug: 'sci-fi-mecha', count: 98, icon: 'ri-rocket-line' },
  { name: '治愈日常', slug: 'healing', count: 156, icon: 'ri-plant-line' },
  { name: '异世界', slug: 'isekai', count: 223, icon: 'ri-door-open-line' },
];

export const allCategories = [
  { name: '热血战斗', slug: 'hot-blooded', description: '燃到爆炸的战斗番，每一帧都是名场面' },
  { name: '奇幻冒险', slug: 'fantasy-adventure', description: '探索未知的世界，踏上史诗旅程' },
  { name: '恋爱日常', slug: 'romance-daily', description: '甜蜜的校园恋爱与温暖的日常故事' },
  { name: '搞笑喜剧', slug: 'comedy', description: '笑到停不下来，治愈一切不开心' },
  { name: '悬疑推理', slug: 'mystery', description: '烧脑的推理情节，层层反转的谜题' },
  { name: '科幻机甲', slug: 'sci-fi-mecha', description: '未来世界与巨型机甲的热血碰撞' },
  { name: '治愈日常', slug: 'healing', description: '温柔的故事，抚平内心的每一道伤痕' },
  { name: '异世界', slug: 'isekai', description: '穿越异世界，开启不一样的人生' },
  { name: '偶像音乐', slug: 'idol-music', description: '闪耀的舞台，追逐梦想的青春物语' },
  { name: '运动竞技', slug: 'sports', description: '挥洒汗水的热血青春，永不言弃的精神' },
];

export const categories = allCategories;

export const regionFilters = [
  { name: '全部地区', slug: 'all' },
  { name: '日本动漫', slug: 'japan' },
  { name: '国产动漫', slug: 'china' },
  { name: '欧美动漫', slug: 'western' },
];

export const yearFilters = [
  { name: '全部年份', slug: 'all' },
  { name: '2025年', slug: '2025' },
  { name: '2024年', slug: '2024' },
  { name: '2023年', slug: '2023' },
  { name: '更早', slug: 'earlier' },
];

export const statusFilters = [
  { name: '全部状态', slug: 'all' },
  { name: '连载中', slug: 'airing' },
  { name: '已完结', slug: 'completed' },
  { name: '即将开播', slug: 'upcoming' },
];

export const categorizedAnimeList = [
  // 热血战斗 (hot-blooded) - 8 items
  { id: 'anime-hb-001', title: '鬼灭之刃 无限城篇', status: '上映中', rating: 9.8, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-001' },
  { id: 'anime-hb-002', title: '咒术回战 死灭回游篇', status: '即将开播', rating: 9.6, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-002' },
  { id: 'anime-hb-003', title: '进击的巨人 完结篇', status: '已完结', rating: 9.5, category: '热血战斗', year: 2024, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-003' },
  { id: 'anime-hb-004', title: '死神 千年血战篇', status: '已完结', rating: 9.2, category: '热血战斗', year: 2024, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-004' },
  { id: 'anime-hb-005', title: '电锯人 第二季', status: '即将开播', rating: 9.4, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-005' },
  { id: 'anime-hb-006', title: '一拳超人 第三季', status: '连载中', rating: 9.1, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-006' },
  { id: 'anime-hb-007', title: '黑色五叶草 续作', status: '连载中', rating: 8.9, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-007' },
  { id: 'anime-hb-008', title: '我的英雄学院 第七季', status: '连载中', rating: 9.0, category: '热血战斗', year: 2025, region: 'japan', slug: 'hot-blooded', imageSeq: 'cat-hb-008' },
  // 奇幻冒险 (fantasy-adventure) - 7 items
  { id: 'anime-fa-001', title: '葬送的芙莉莲 第二季', status: '连载中', rating: 9.7, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-001' },
  { id: 'anime-fa-002', title: '迷宫饭 第二季', status: '连载中', rating: 9.2, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-002' },
  { id: 'anime-fa-003', title: '无职转生 第三季', status: '即将开播', rating: 9.3, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-003' },
  { id: 'anime-fa-004', title: '盾之勇者成名录 第四季', status: '连载中', rating: 8.7, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-004' },
  { id: 'anime-fa-005', title: '平凡职业成就世界最强 第三季', status: '已完结', rating: 8.4, category: '奇幻冒险', year: 2024, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-005' },
  { id: 'anime-fa-006', title: '魔王学院的不适任者 第三季', status: '连载中', rating: 8.6, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-006' },
  { id: 'anime-fa-007', title: '狩龙人拉格纳 第二季', status: '即将开播', rating: 8.8, category: '奇幻冒险', year: 2025, region: 'japan', slug: 'fantasy-adventure', imageSeq: 'cat-fa-007' },
  // 恋爱日常 (romance-daily) - 6 items
  { id: 'anime-rd-001', title: '堀与宫村 第二季', status: '已完结', rating: 9.1, category: '恋爱日常', year: 2024, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-001' },
  { id: 'anime-rd-002', title: '我心里危险的东西 第三季', status: '连载中', rating: 9.3, category: '恋爱日常', year: 2025, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-002' },
  { id: 'anime-rd-003', title: '久保同学不放过我', status: '已完结', rating: 8.5, category: '恋爱日常', year: 2024, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-003' },
  { id: 'anime-rd-004', title: '擅长捉弄的高木同学 剧场版', status: '已完结', rating: 9.0, category: '恋爱日常', year: 2024, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-004' },
  { id: 'anime-rd-005', title: '总之就是非常可爱 第三季', status: '连载中', rating: 8.8, category: '恋爱日常', year: 2025, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-005' },
  { id: 'anime-rd-006', title: '地狱乐园 第二季', status: '已完结', rating: 8.6, category: '恋爱日常', year: 2024, region: 'japan', slug: 'romance-daily', imageSeq: 'cat-rd-006' },
  // 搞笑喜剧 (comedy) - 6 items
  { id: 'anime-cm-001', title: '间谍过家家 第三季', status: '连载中', rating: 9.3, category: '搞笑喜剧', year: 2025, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-001' },
  { id: 'anime-cm-002', title: '辉夜大小姐想让我告白 剧场版', status: '已完结', rating: 9.4, category: '搞笑喜剧', year: 2024, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-002' },
  { id: 'anime-cm-003', title: '物理魔法使马修 第三季', status: '连载中', rating: 8.7, category: '搞笑喜剧', year: 2025, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-003' },
  { id: 'anime-cm-004', title: '阿松 第四季', status: '已完结', rating: 8.5, category: '搞笑喜剧', year: 2024, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-004' },
  { id: 'anime-cm-005', title: '极主夫道 第二季', status: '已完结', rating: 8.3, category: '搞笑喜剧', year: 2024, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-005' },
  { id: 'anime-cm-006', title: '在异世界迷宫开后宫 第二季', status: '连载中', rating: 7.9, category: '搞笑喜剧', year: 2025, region: 'japan', slug: 'comedy', imageSeq: 'cat-cm-006' },
  // 悬疑推理 (mystery) - 5 items
  { id: 'anime-my-001', title: '黑执事 寄宿学校篇', status: '已完结', rating: 9.1, category: '悬疑推理', year: 2024, region: 'japan', slug: 'mystery', imageSeq: 'cat-my-001' },
  { id: 'anime-my-002', title: '夏日重现 第二季', status: '已完结', rating: 9.2, category: '悬疑推理', year: 2024, region: 'japan', slug: 'mystery', imageSeq: 'cat-my-002' },
  { id: 'anime-my-003', title: '虚构推理 第三季', status: '即将开播', rating: 8.9, category: '悬疑推理', year: 2025, region: 'japan', slug: 'mystery', imageSeq: 'cat-my-003' },
  { id: 'anime-my-004', title: '不死少女的谋杀闹剧', status: '已完结', rating: 8.4, category: '悬疑推理', year: 2024, region: 'japan', slug: 'mystery', imageSeq: 'cat-my-004' },
  { id: 'anime-my-005', title: '时光代理人 第三季', status: '连载中', rating: 9.3, category: '悬疑推理', year: 2025, region: 'china', slug: 'mystery', imageSeq: 'cat-my-005' },
  // 科幻机甲 (sci-fi-mecha) - 5 items
  { id: 'anime-sm-001', title: '机动战士高达 水星的魔女 完结篇', status: '已完结', rating: 9.0, category: '科幻机甲', year: 2024, region: 'japan', slug: 'sci-fi-mecha', imageSeq: 'cat-sm-001' },
  { id: 'anime-sm-002', title: 'EVA新剧场版：终', status: '已完结', rating: 9.3, category: '科幻机甲', year: 2024, region: 'japan', slug: 'sci-fi-mecha', imageSeq: 'cat-sm-002' },
  { id: 'anime-sm-003', title: '86-不存在的战区 第二季', status: '已完结', rating: 9.1, category: '科幻机甲', year: 2024, region: 'japan', slug: 'sci-fi-mecha', imageSeq: 'cat-sm-003' },
  { id: 'anime-sm-004', title: '赛博朋克：边缘行者 续篇', status: '即将开播', rating: 9.5, category: '科幻机甲', year: 2025, region: 'japan', slug: 'sci-fi-mecha', imageSeq: 'cat-sm-004' },
  { id: 'anime-sm-005', title: '灵笼 第二季', status: '连载中', rating: 9.2, category: '科幻机甲', year: 2025, region: 'china', slug: 'sci-fi-mecha', imageSeq: 'cat-sm-005' },
  // 治愈日常 (healing) - 5 items
  { id: 'anime-hl-001', title: '摇曳露营△ 第四季', status: '连载中', rating: 9.4, category: '治愈日常', year: 2025, region: 'japan', slug: 'healing', imageSeq: 'cat-hl-001' },
  { id: 'anime-hl-002', title: '夏目友人帐 第七季', status: '连载中', rating: 9.6, category: '治愈日常', year: 2025, region: 'japan', slug: 'healing', imageSeq: 'cat-hl-002' },
  { id: 'anime-hl-003', title: '三月的狮子 第三季', status: '即将开播', rating: 9.5, category: '治愈日常', year: 2025, region: 'japan', slug: 'healing', imageSeq: 'cat-hl-003' },
  { id: 'anime-hl-004', title: '妖精森林的小不点 第二季', status: '已完结', rating: 9.0, category: '治愈日常', year: 2024, region: 'japan', slug: 'healing', imageSeq: 'cat-hl-004' },
  { id: 'anime-hl-005', title: '相合之物 第二季', status: '连载中', rating: 8.9, category: '治愈日常', year: 2025, region: 'japan', slug: 'healing', imageSeq: 'cat-hl-005' },
  // 异世界 (isekai) - 6 items
  { id: 'anime-is-001', title: 'Re：从零开始的异世界生活 第三季', status: '连载中', rating: 9.4, category: '异世界', year: 2025, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-001' },
  { id: 'anime-is-002', title: '关于我转生变成史莱姆这档事 第四季', status: '连载中', rating: 9.2, category: '异世界', year: 2025, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-002' },
  { id: 'anime-is-003', title: 'OVERLORD 第五季', status: '即将开播', rating: 9.1, category: '异世界', year: 2025, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-003' },
  { id: 'anime-is-004', title: '想要成为影之实力者 第三季', status: '连载中', rating: 8.8, category: '异世界', year: 2025, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-004' },
  { id: 'anime-is-005', title: '为美好的世界献上祝福 第四季', status: '即将开播', rating: 9.2, category: '异世界', year: 2025, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-005' },
  { id: 'anime-is-006', title: '转生贵族的异世界冒险录 第二季', status: '已完结', rating: 8.2, category: '异世界', year: 2024, region: 'japan', slug: 'isekai', imageSeq: 'cat-is-006' },
  // 偶像音乐 (idol-music) - 5 items
  { id: 'anime-im-001', title: '我推的孩子 第三季', status: '连载中', rating: 9.5, category: '偶像音乐', year: 2025, region: 'japan', slug: 'idol-music', imageSeq: 'cat-im-001' },
  { id: 'anime-im-002', title: 'Love Live! Superstar!! 第四季', status: '连载中', rating: 8.7, category: '偶像音乐', year: 2025, region: 'japan', slug: 'idol-music', imageSeq: 'cat-im-002' },
  { id: 'anime-im-003', title: 'BanG Dream! Ave Mujica', status: '连载中', rating: 9.0, category: '偶像音乐', year: 2025, region: 'japan', slug: 'idol-music', imageSeq: 'cat-im-003' },
  { id: 'anime-im-004', title: '蓝色管弦乐 第二季', status: '已完结', rating: 8.6, category: '偶像音乐', year: 2024, region: 'japan', slug: 'idol-music', imageSeq: 'cat-im-004' },
  { id: 'anime-im-005', title: '偶像大师 闪耀色彩 第二季', status: '已完结', rating: 8.4, category: '偶像音乐', year: 2024, region: 'japan', slug: 'idol-music', imageSeq: 'cat-im-005' },
  // 运动竞技 (sports) - 5 items
  { id: 'anime-sp-001', title: '蓝色监狱 第二季', status: '连载中', rating: 9.1, category: '运动竞技', year: 2025, region: 'japan', slug: 'sports', imageSeq: 'cat-sp-001' },
  { id: 'anime-sp-002', title: '排球少年!! FINAL 剧场版', status: '已完结', rating: 9.7, category: '运动竞技', year: 2024, region: 'japan', slug: 'sports', imageSeq: 'cat-sp-002' },
  { id: 'anime-sp-003', title: '黑子的篮球 新作', status: '即将开播', rating: 8.8, category: '运动竞技', year: 2025, region: 'japan', slug: 'sports', imageSeq: 'cat-sp-003' },
  { id: 'anime-sp-004', title: '青之芦苇 第二季', status: '连载中', rating: 8.9, category: '运动竞技', year: 2025, region: 'japan', slug: 'sports', imageSeq: 'cat-sp-004' },
  { id: 'anime-sp-005', title: '钻石王牌 act III', status: '已完结', rating: 9.2, category: '运动竞技', year: 2024, region: 'japan', slug: 'sports', imageSeq: 'cat-sp-005' },
];
